import { DefaultPage, ProjectLoader, EditSnippet } from './';

export default {
  path: 'editor/:version/v',
  name: 'Editor',
  childRoutes: [
    { path: ':projectId/pages/:pageId', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/loader',
      name: 'Project loader',
      component: ProjectLoader,
      isPrivate: true,
    },
    {
      path: ':projectId/snippets/:templateId',
      name: 'Edit snippet',
      component: EditSnippet,
      isPrivate: true,
    },
  ],
};
